import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import updateQuantity from '../../../../actions/updateQuantity';
import QuantityContainer from './QuantityContainer';

const mapDispatchToProps = dispatch => bindActionCreators({ updateQuantity }, dispatch);

const mapStateToProps = ({ estimateBuilder }, { itemId }) => {
  const { entities: { estimates, items }, uiState: { selectedEstimate } } = estimateBuilder;
  const { attributes: { isMandi, isAutoReleaseDesign } } = estimates.byId[selectedEstimate];
  const {
    itemProduct,
    retail,
    subtotal,
    quantity,
  } = items.byId[itemId];

  const lineItemRetail = itemProduct.retail;

  return {
    isMandi,
    isAutoReleaseDesign: isAutoReleaseDesign === 'true',
    itemId,
    retail,
    subtotal,
    quantity,
    lineItemRetail,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuantityContainer);
